<template>
  <div>
    <div
      v-for="(section,idx) in options"
      :key="idx"
      class="mt-4"
    >
      <h3 class="uppercase font-semibold text-sm tracking-wide text-gray-600">
        {{ section.label}}
      </h3>
      <m-checkbox-item
        v-for="(option,idx) in section.options"
        :key="idx"
        class="mt-4"
        :value="option.value"
        v-model="selections[section.label][option.value]"
        :disabled="option.children && option.children.length > 0"
        :checked="selections[section.label][option.value].length > 0"
      >
        <div v-if="option.children" class="ml-8 mt-2">
          <m-checkbox
            :options="option.children"
            v-model="selections[section.label][option.value]"
          >
          </m-checkbox>
        </div>
      </m-checkbox-item>
    </div>
    <div class="mt-8 bg-gray-100 p-4 rounded overflow-hidden">
      <pre>{{ selections}}</pre>
    </div>
  </div>
</template>

<script>
import options from '@/app/utils/toolkit/business-rules/inv-strat-review/reviewReasons';

export default {
  data: () => ({
    options,
    selections: {},
  }),
  computed: {
    sections() {
      return this.options.flatMap(section => ({
        label: section.label,
        options: section.options.flatMap(option => option.value),
      }));
    },
    children() {
      return option => option.children;
    },
  },
  created() {
    this.selections = this.options.reduce((curr, prev) => {
      curr[prev.label] = {};
      prev.options.forEach((option) => {
        if (option.children) {
          curr[prev.label][option.value] = [];
        } else {
          curr[prev.label][option.value] = false;
        }
      });
      return curr;
    }, {});
  },
};
</script>

<style>

</style>
